import React from 'react';

const AnimatedToggle = ({ checked, onChange }) => {
  return (
    <button
      aria-pressed={checked}
      onClick={onChange}
      className={`animated-toggle ${checked ? 'is-on' : 'is-off'}`}
      title={checked ? 'Switch to light' : 'Switch to dark'}
    >
      <span className="track" />
      <span className="knob">
        <svg className="icon-sun" viewBox="0 0 24 24" width="18" height="18" aria-hidden>
          <circle cx="12" cy="12" r="4" fill="#FDBA74" />
        </svg>
        <svg className="icon-moon" viewBox="0 0 24 24" width="18" height="18" aria-hidden>
          <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" fill="#CBD5E1" />
        </svg>
      </span>
    </button>
  );
};

export default AnimatedToggle;
